<template>
    <div class="fund-list">
        <el-row v-if="fundInfo.length <= 0 && hasLoad" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>{{ noFundMsg }}</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-else-if="hasLoad"
            :data="fundAll"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: '#F9F9F9' }"
        >
            <el-table-column
                :label="isCollection ? '产品名称' : '基金名称'"
                width="280"
                class-name="fund-offset"
            >
                <template slot-scope="scope">
                    <div class="fund-name" v-on:click.stop="gotoDetail(scope.row)">
                        {{ scope.row.fundname }}
                    </div>
                    <div style="color: #999999">
                        {{ scope.row.fundcode }}
                    </div>
                </template>
            </el-table-column>
            <template v-if="isCollection">
                <el-table-column label="产品类型" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{
                                scope.row.fundshowtype
                                    ? $cache.getDict("130086", scope.row.fundshowtype)
                                    : ""
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="最新净值" align="center">
                    <template slot-scope="scope">
                        <div>{{ $util.fmtNum(scope.row.nav, 4) }}</div>
                        <div v-if="scope.row.nav" style="color: #999999">
                            {{ $util.fmtDate(scope.row.navdate) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="日涨幅" align="center">
                    <template slot-scope="scope">
                        <span :class="$util.colorClass($util.fmtNum(scope.row.dayfloatprofit))">
                            {{ formatterRate(scope.row.dayfloatprofit) }}
                        </span>
                    </template>
                </el-table-column>
            </template>
            <template v-else>
                <el-table-column label="每万份收益" align="center">
                    <template slot-scope="scope">
                        <div :class="$util.colorClass($util.fmtNum(scope.row.fundincomeunit, 4))">
                            {{ $util.fmtNum(scope.row.fundincomeunit, 4) }}
                        </div>
                        <div v-if="scope.row.fundincomeunit" style="color: #999999">
                            {{ $util.fmtDate(scope.row.navdate) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="七日年化收益" align="center">
                    <template slot-scope="scope">
                        <span
                            :class="
                                $util.colorClass($util.fmtNum(formatterRate(scope.row.growthrate)))
                            "
                        >
                            {{ formatterRate(scope.row.growthrate) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="近半年" align="center">
                    <template slot-scope="scope">
                        <span :class="$util.colorClass(formatterRate(scope.row.month6ud))">
                            {{ formatterRate(scope.row.month6ud) }}
                        </span>
                    </template>
                </el-table-column>
            </template>
            <el-table-column label="近一年" align="center">
                <template slot-scope="scope">
                    <span :class="$util.colorClass(formatterRate(scope.row.year1ud))">
                        {{ formatterRate(scope.row.year1ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="今年以来" align="center">
                <template slot-scope="scope">
                    <span :class="$util.colorClass(formatterRate(scope.row.thisyear1ud))">
                        {{ formatterRate(scope.row.thisyear1ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="成立以来" align="center" width="100">
                <template slot-scope="scope">
                    <span :class="$util.colorClass(formatterRate(scope.row.allud))">
                        {{ formatterRate(scope.row.allud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="160">
                <template slot-scope="scope">
                    <div class="btns">
                        <template v-if="url !== 'glist'">
                            <el-tooltip
                                v-if="scope.row.isBuy"
                                class="item"
                                effect="info"
                                :content="scope.row.isBuy + '，不能申购'"
                                placement="top"
                            >
                                <el-button disabled type="text" size="small">申购</el-button>
                            </el-tooltip>
                            <el-button
                                v-else
                                type="text"
                                plain
                                size="small"
                                v-on:click.stop="callbackFn('20,22', scope.row)"
                            >
                                {{ scope.row.status == "1" ? "认购" : "申购" }}
                            </el-button>
                            <div class="line"></div>
                        </template>
                        <el-tooltip
                            v-if="scope.row.isCurrency"
                            class="item"
                            effect="info"
                            :content="scope.row.isCurrency + '，不能定投'"
                            placement="top"
                        >
                            <el-button type="text" disabled size="small">定投</el-button>
                        </el-tooltip>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('59', scope.row)"
                        >
                            定投
                        </el-button>
                        <template v-if="url !== 'glist'">
                            <div class="line"></div>
                            <el-button
                                v-if="scope.row.collection == '0'"
                                type="text"
                                plain
                                size="small"
                                style="width: 60px"
                                v-on:click.stop="collectFund(scope.row)"
                            >
                                加自选
                            </el-button>
                            <el-button
                                v-else
                                type="text"
                                plain
                                size="small"
                                style="width: 60px"
                                v-on:click.stop="unCollectFund(scope.row)"
                            >
                                取消自选
                            </el-button>
                        </template>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="dataReset"
            />
        </el-row>
    </div>
</template>

<script>
import fundApi from "@/api/fund";

export default {
    name: "FundList",
    props: {
        fundInfo: {
            type: Array,
            default: () => {
                return [];
            },
            required: true
        },
        allPage: {
            type: String,
            default: ""
        },
        noFundMsg: {
            type: String,
            default: "基金公司没有添加基金产品，请联系基金公司添加！ "
        },
        isCollection: {
            type: Boolean,
            default: false
        },
        hasLoad: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            url: "", // 当前页面路由命名
            fundAll: [],
            curPage: 1
        };
    },
    watch: {
        fundInfo() {
            this.getNewFund();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    mounted() {
        this.conf = this.$util.getConfig().const;
        this.url = this.$route.name;
    },
    methods: {
        // 跳转到基金详情
        gotoDetail(val) {
            this.$util.toFundDetail(val.fundcode);
        },
        // 关注基金
        async collectFund(item) {
            const res = await fundApi.collectFund({
                fundcode: item.fundcode
            });
            if (!res.error) {
                this.$set(this.fundAll[item.index], "collection", "1");
            }
        },
        // 取消关注基金
        async unCollectFund(item) {
            const res = await fundApi.unCollectFund({
                fundcode: item.fundcode
            });
            if (!res.error) {
                this.$set(this.fundAll[item.index], "collection", "0");
            }
        },
        callbackFn(way, fund) {
            let moduleId = "";
            if (way == "59") {
                moduleId = way;
            } else {
                if (fund.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            }
            // 申购 22 认购 20
            this.$util.checkGtOcrModule(moduleId, "0", (res) => {
                this.$emit("fund-continue", way, fund);
            });
        },
        getNewFund() {
            let _arr = [];
            this.fundInfo.forEach((fund, index) => {
                const _x = Object.assign({}, fund);
                _x.index = index;
                _x.isBuy = this.$util.checkBuy(_x.status);
                _x.isCurrency = this.$util.checkGeneral(_x);
                _arr.push(_x);
            });
            this.fundAll = _arr;
        },
        dataReset(val) {
            this.$emit("new-fund", val);
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (!rate) {
                return "--";
            }
            const prefix = Number(rate) > 0 ? "+" : "";
            return prefix + this.$util.fmtNum(rate) + "%";
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.fund-list {
    padding-bottom: 0;
    .el-table td.el-table__cell div {
        color: #333333;
    }
    .el-table td.el-table__cell span {
        color: #333333;
        &.add {
            color: $risk5;
        }
        &.reduce {
            color: $risk1;
        }
    }
    .el-table--fit {
        margin-bottom: 20px;
    }
    .fund-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
    }
    .collection-name {
        font-weight: 400;
        font-size: 14px;
    }
    .btns {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 11px;
    }
    .line {
        background: #e8e8e8;
        width: 1px;
        height: 12px;
    }
    .el-button.is-plain:hover,
    .el-button.is-plain:focus,
    .el-button.is-disabled.is-plain {
        background-color: transparent;
        border-color: transparent;
    }
    .el-button--text {
        font-size: 14px;
        font-weight: normal;
        color: #e60012;
    }
    .el-button--text.is-disabled {
        color: #cccccc;
    }
    .el-table {
        border: 1px solid #f1f1f1;
    }
    .page-box {
        padding: 0;
    }
    .el-pagination {
        margin-bottom: 0;
    }
}
</style>
